import { Row } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { nullSafeGet } from '../../../utils/DataAccessUtils';
import { QuoteRowDisplay } from '../../quote_row_display/QuoteRowDisplay';
import { getLinkWIthBackLinkParams } from '../../../utils/HistoryUtils';
import { getQuoteSubURL } from '../../quote_utils/QuoteUtils';

function QuotesTableRow({
	location,
	record,
	userType,
	backText,
	selections,
	targetCollectionName,
	currentUser,
}) {
	const BACK_TEXT = backText || 'Back to quotes';
	const quotePathName = getQuoteSubURL(userType, currentUser, record);

	const getLink = () => {
		const path = `/${quotePathName}/detail/${nullSafeGet('id', record)}/details${
			targetCollectionName ? `?targetCollectionName=${targetCollectionName}` : ''
		}`;
		return getLinkWIthBackLinkParams(location, BACK_TEXT, path, {
			preserve: true,
		});
	};
	return (
		<Row>
			<Link to={getLink()} style={{ width: '100%' }}>
				<QuoteRowDisplay quote={record} location={location} currentUser={currentUser} />
			</Link>
		</Row>
	);
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(QuotesTableRow);
